import type { FaireProductEntity } from "../../entity_types/product";

export const p_cjmfruysay: FaireProductEntity = {
  token: "p_cjmfruysay",
  type: "product",
  name: "Tall Lantern with Handle-Natural",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/e45e04362194cf522590a6c193df7f8b7aa82bdea480f3b6fb1da4ced762499e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/19eb73dde387fad36727ee36ff4f4f52ac12f243ce4e1d14d5cec615caa34ba0.jpeg",
    "https://cdn.faire.com/fastly/af8d0527c0d95048f6dc5714416a1446f45a7cb41cbaa30df459c72cb1a99ab2.jpeg",
    "https://cdn.faire.com/fastly/50ec9fd999883dc560da40e45abe8ba75cc978bf3e7c7eb8d2fc8acf24575be0.jpeg",
    "https://cdn.faire.com/fastly/5ce594d93d78ff2b687d3c106c7843dd2177e1e61c0cdc07c3b000601fec9316.jpeg",
    "https://cdn.faire.com/fastly/bb834634b7f44a6a3022595b1642532c862d0cdcb8b97eaa424c48e15c9fadd0.jpeg",
    "https://cdn.faire.com/fastly/9615692509d64af6dd3ec19904cd01629cc231c072140795fe2b755304c93df9.jpeg",
    "https://cdn.faire.com/fastly/cad0976df72a03e56ad426a0bdf9b3a04c34b53761edc1f249d26ff1a2e72d1c.jpeg",
  ],
  priceDollars: 50,
  description:
    'A compact statement in natural tones, this tall lantern pairs linen-style fabric with bamboo framing for a clean, earthy aesthetic. Due to the natural materials, this lantern is more suited for indoor use. If using outdoor, use in fair weather and store indoors. Available in Large (16"H), Medium (13.5"H) and Small (11"H)',
  tags: [],
  msrpDollars: 100,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:11.805Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
